<template>
    <div>
        <loading-component :value="loading"/>
        <path-drawer v-if="!loading && pathDrawer" :ride="ride.id"/>
        <v-card v-if="!loading">
            <v-card-title primary-title class="title font-weight-bold">
                Ride #{{id}}
                <v-spacer/>
                <v-checkbox
                        label="Show Path drawer" v-model="pathDrawer"/>
                <v-spacer/>
            </v-card-title>
            <v-divider/>
            <v-card>
                <v-card-title primary-title class="font-weight-bold headline"> Summary
                    <v-btn color="red" @click="dialog = true"
                           v-show="ride.meter && hasPermission('MANAGE_TRANSACTION')">Edit
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="ride.meter">
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md4>
                            Kms :
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            {{Number(ride.meter.km_count).toFixed(2)}}
                        </v-flex>
                        <v-flex offset-md4/>
                        <v-flex xs12 sm6 md4>
                            Elapsed Time :
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            {{Number(ride.meter.elapsed_time).toFixed(2)}}
                        </v-flex>
                        <v-flex offset-md4/>
                        <v-flex xs12 sm6 md4>
                            Waiting time :
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            {{Number(ride.meter.waiting_time).toFixed(2)}}
                        </v-flex>
                        <v-flex offset-md4/>
                        <v-flex xs12 sm6 md4>
                            Meter Price :
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            {{Number(ride.meter.meter_price).toFixed(2)}}
                        </v-flex>
                        <v-flex offset-md4/>
                        <v-flex xs12 sm6 md4>
                            Flagged :
                        </v-flex>
                        <v-flex xs12 sm6 md4 :style="{color: ride.meter.flag ? 'red' : 'green'}">
                            {{ride.meter.flag ? 'Yes' : 'No'}}
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text v-else class="text-xs-center">
                    (Not Done Yet)
                </v-card-text>
                <v-expansion-panel v-if="ride.meter_history.length" style="margin-bottom: 5px">
                    <v-expansion-panel-content>
                        <div slot="header" class="mt-2 font-weight-bold title">
                            Meter price history
                        </div>
                        <v-card>
                            <v-card-text>
                                <v-layout row wrap>
                                    <template>
                                        <v-flex xs6
                                                class="mt-2 font-weight-bold text-xs-center"
                                                style="border-bottom: 1px solid #000000DD">
                                            Meter
                                        </v-flex>
                                        <v-flex xs6 class="mt-2 font-weight-bold text-xs-center"
                                                style="border-bottom: 1px solid #000000DD">
                                            Date
                                        </v-flex>
                                        <v-divider/>
                                    </template>
                                    <template v-for="meter of ride.meter_history">
                                        <v-flex xs6
                                                class="mt-2 font-weight-bold text-xs-center"
                                                style="border-bottom: 1px solid #000000DD">
                                            {{meter.meter_price}}
                                        </v-flex>
                                        <v-flex xs6 class="mt-2 font-weight-bold text-xs-center"
                                                style="border-bottom: 1px solid #000000DD">
                                            {{moment(meter.created_at).format('YYYY-MM-DD HH:mm:ss')}}
                                        </v-flex>
                                        <v-divider/>
                                    </template>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-layout row wrap v-else>
                    <template>
                        <v-flex xs12
                                class="mt-2 font-weight-bold text-xs-center">
                            No meter price history
                        </v-flex>
                    </template>
                </v-layout>
                <v-card-title>
                    <v-layout row class="headline">
                        <v-flex xs12 sm6 md4>
                            Captain:
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <router-link :to="{name: 'CaptainProfile', params: {id :ride.captain.id}}"
                                         target="_blank">
                                {{ride.captain.first_name}} {{ride.captain.last_name}}
                            </router-link>
                        </v-flex>
                    </v-layout>
                </v-card-title>

            </v-card>
            <v-divider/>
            <v-card-text>
                <template v-for="booking of ride.bookings">
                    <v-card>
                        <v-card-title class="subheading font-weight-bold">
                            Passenger:
                            <router-link :to="{name: 'PassengerProfile', params: {id :booking.passenger.id}}"
                                         target="_blank">
                                {{booking.passenger.first_name }} {{booking.passenger.last_name}}
                            </router-link>
                            &nbsp;&nbsp;B#{{booking.id}}
                            <v-btn color="red" v-show="booking.status === 'PAID' && hasPermission('MANAGE_TRANSACTION')"
                                   @click="selectBooking(booking)">Edit
                            </v-btn>
                        </v-card-title>
                        <v-divider/>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    Creation Date:
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{moment(booking.created_at).format("YYYY-MM-DD HH:mm")}}
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    Datetime:
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{moment(booking.datetime).format("YYYY-MM-DD HH:mm")}}
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    Service:
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{booking.service.name}}
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    Current Status:
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="font-weight-bold">
                                    {{booking.status}}
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    Using Voucher:
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <div v-if="booking.voucher" class="green--text">Yes ({{booking.voucher.code}})</div>
                                    <div v-else class="red--text">No</div>
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    From:
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{booking.pick_up_location_name}}
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    From (Details):
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{booking.pick_up_location_details}}
                                </v-flex>
                                <v-flex offset-md4/>

                                <template v-if="booking.stops && booking.stops.length">
                                    <v-flex xs12 sm6 md4>
                                        Stop:
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        {{booking.stops[0].location_name}}
                                    </v-flex>
                                    <v-flex offset-md4/>
                                </template>
                                <v-flex xs12 sm6 md4>
                                    To:
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{booking.pull_down_location_name}}
                                </v-flex>
                                <v-flex offset-md4/>
                                <v-flex xs12 sm6 md4>
                                    To (Details):
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    {{booking.pull_down_location_details}}
                                </v-flex>

                                <v-flex v-if="booking.status === 'PAID'" offset-md4/>
                                <v-flex v-if="booking.status === 'PAID'" xs12 sm6 md4>
                                    To Pay:
                                </v-flex>
                                <v-flex v-if="booking.status === 'PAID'" xs12 sm6 md4>
                                    {{booking.to_pay}}
                                </v-flex>
                                <v-flex v-if="booking.status === 'PAID'" offset-md4/>
                                <v-flex v-if="booking.status === 'PAID'" xs12 sm6 md4>
                                    Paid:
                                </v-flex>
                                <v-flex v-if="booking.status === 'PAID'" xs12 sm6 md4>
                                    {{booking.paid}}
                                </v-flex>

                                <template v-if="booking.summary">
                                    <v-flex offset-md4/>
                                    <v-flex xs12 sm6 md4>
                                        Ghost:
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        {{Number(booking.summary.ghost_km).toFixed(2)}} KM
                                    </v-flex>
                                    <v-flex offset-md4/>
                                    <v-flex xs12 sm6 md4>
                                        Estimated KM:
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        {{Number(booking.summary.estimated_distance).toFixed(2)}} KM
                                    </v-flex>
                                    <v-flex offset-md4/>
                                    <v-flex xs12 sm6 md4>
                                        Estimated Time:
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        {{Number(booking.summary.estimated_time).toFixed(2)}} M
                                    </v-flex>
                                    <v-flex offset-md4/>
                                    <v-flex xs12 sm6 md4>
                                        Estimated Price:
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        {{Number(booking.summary.estimated_price).toFixed(2)}} S.P
                                    </v-flex>
                                    <v-flex offset-md4/>
                                    <v-flex xs12 sm6 md4>
                                        Lateness
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        {{lateness[booking.id]}}
                                    </v-flex>
                                </template>
                            </v-layout>
                            <v-expansion-panel style="margin-bottom: 5px">
                                <v-expansion-panel-content>
                                    <div slot="header" class="mt-2 font-weight-bold title">
                                        Paying history (total: {{booking.paid}})
                                    </div>
                                    <v-card>
                                        <v-card-text>
                                            <v-layout row wrap v-if="booking.paying_history.length">
                                                <template>
                                                    <v-flex xs6
                                                            class="mt-2 font-weight-bold text-xs-center"
                                                            style="border-bottom: 1px solid #000000DD">
                                                        Transaction
                                                    </v-flex>
                                                    <v-flex xs6 class="mt-2 font-weight-bold text-xs-center"
                                                            style="border-bottom: 1px solid #000000DD">
                                                        Date
                                                    </v-flex>
                                                    <v-divider/>
                                                </template>
                                                <template v-for="pay of booking.paying_history">
                                                    <v-flex xs6
                                                            class="mt-2 font-weight-bold text-xs-center"
                                                            style="border-bottom: 1px solid #000000DD">
                                                        <span :style="pay.is_credit?'color:green' : 'color:red'">{{pay.amount}}</span>
                                                    </v-flex>
                                                    <v-flex xs6 class="mt-2 font-weight-bold text-xs-center"
                                                            style="border-bottom: 1px solid #000000DD">
                                                        {{pay.created_at}}
                                                    </v-flex>
                                                    <v-divider/>
                                                </template>
                                            </v-layout>
                                            <v-layout row wrap v-else>
                                                <v-flex xs12 class="mt-2 font-weight-bold text-xs-center">
                                                    No pay transactions
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-content>
                                    <div slot="header" class="mt-2 font-weight-bold title">
                                        Actions
                                    </div>
                                    <v-card>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <template v-for="status of booking.statuses">
                                                    <v-flex xs6
                                                            class="mt-2 font-weight-bold text-xs-center"
                                                            style="border-bottom: 1px solid #000000DD">
                                                        <v-label color="primary">
                                                            {{status.status}}
                                                            <router-link
                                                                    v-if="status.status === 'APPROVED' && status.captain_id !== null"
                                                                    :to="{name: 'CaptainProfile', params: {id :status.captain_id}}"
                                                                    target="_blank">
                                                                (Cax {{status.captain.first_name}}
                                                                {{status.captain.last_name}} )

                                                            </router-link>
                                                        </v-label>
                                                    </v-flex>
                                                    <v-flex xs6 class="mt-2 font-weight-bold text-xs-center" style="border-bottom: 1px solid #000000DD">
                                                        {{moment(status.created_at).format("YYYY-MM-DD HH:mm")}}
                                                    </v-flex>
                                                    <v-divider/>
                                                </template>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-card-text>
                    </v-card>
                    <v-divider/>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import PathDrawer from "@/views/monitoring/PathDrawer";
    import moment from "moment";
    import _ from "lodash";

    export default {
        name: "RidePage",
        components: {PathDrawer, LoadingComponent},
        title: "Ride",
        props: {
            'ride_id': {},
            show_end_ride: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            editRideExplain() {
                return (this.ride.meter ? (this.ride.meter.meter_price < this.edit_ride.meter_price ? ' ( CAPTAIN REFUND)' :
                    (this.ride.meter.meter_price > this.edit_ride.meter_price ? ' ( PASSENGER REFUND)' : '')) : '');
            },
            editBookingExplain() {
                return (this.selected_booking ? (this.selected_booking.paid < this.edit_booking.paid ? ' (CAPTAIN Cash out)' :
                    (this.selected_booking.paid > this.edit_booking.paid ? ' (Passenger Cash out)' : '')) : '');
            },
            lateness() {
                return Object.assign({}, ...this.ride.bookings.map(
                    ({id, datetime, status, statuses}) => {
                        let val;
                        const lastArrive = _.last(statuses.filter(({status}) => status === "ARRIVED"));


                        if (["PICKED_UP", "DONE", "PAID", "CANCELLED"].indexOf(status) !== -1)
                            val = "No one is late";
                        else {
                            if (status === "ARRIVED" && moment() > moment(datetime))
                                val = `Passenger is late ${moment().diff(lastArrive.created_at, 'minute')} Minutes`;
                            else if (status !== "ARRIVED" && moment() > moment(datetime)) {
                                val = `Captain is late ${moment().diff(datetime, "minute")} Minutes`;
                            } else val = `No one is late`;
                        }

                        return {
                            [id]: val
                        };
                    }
                ));
            }
        },
        watch: {
            ride_id(val) {
                this.id = val;
                this.getData();
            }
        },
        data() {
            return {
                numberRules: [
                    v => !!v || 'Required field',
                    v => /^[0-9]*$/.test(v) || 'invalid value'
                ],
                requiredRules: [
                    v => !!v || 'Field is required'
                ],
                edit_ride: {
                    meter_price: 0,
                    refunder: ""
                },
                edit_booking: {
                    paid: 0
                },
                selected_booking: {},
                dialog: false,
                dialog2: false,
                valid: false,
                valid2: false,
                pathDrawer: false,
                id: this.ride_id ? this.ride_id : this.$route.params.id,
                loading: false,
                ride: {
                    meter_history: [],
                    bookings: [{
                        id: null,
                        datetime: null,
                        passenger: {
                            id: null,
                            username: null,
                            first_name: null,
                            last_name: null,
                            whatsapp_number: null,
                        },
                        paying_history: [],
                        summary: {
                            estimated_time: 0,
                            estimated_price: 0,
                            estimated_distance: 0,
                        },
                        service: {
                            name: null
                        },
                        pick_up_location: null,
                        pull_down_location: null,
                        pick_up_location_name: null,
                        pull_down_location_name: null,
                        pick_up_location_details: null,
                        pull_down_location_details: null,
                        status: null,
                        statuses: [],
                        stops: [],
                        voucher: {
                            code: null
                        },
                        created_at: null
                    }],
                    captain: {},
                    id: null,
                    meter: {
                        km_count: null,
                        elapsed_time: null,
                        waiting_time: null,
                        meter_price: null
                    },
                    service: {}
                }
            }
        },
        methods: {
            saveEditRide() {
                if (!this.ride.meter || !this.$refs.form.validate()) {
                    return;
                }
                if (this.ride.meter.meter_price === this.edit_ride.meter_price) {
                    this.dialog = false;
                    window.getApp.$emit("SHOW_TOAST", "no changes", "default");
                    return;
                }
                this.loading = true;
                this.axios.put(`ride/${this.ride.id}/meter`, {
                    amount: this.edit_ride.meter_price,
                    refunder: this.edit_ride.refunder
                }).then(() => {
                    this.dialog = false;
                    this.ride.meter.meter_price = this.edit_ride.meter_price;
                    window.getApp.$emit("SHOW_TOAST", 'success', "green");
                }).catch(err => {
                    try {
                        if (err.response.data.message) {
                            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
                        } else {
                            window.getApp.$emit("SHOW_TOAST", err.message, "red");
                        }
                    } catch (e) {
                        console.log(err.message, e.message);
                    }
                }).finally(() => this.loading = false);
            },
            getData() {
                this.loading = true;
                this.axios(this.api.ACTIONS.RIDE + '/' + this.id)
                    .then(({data}) => {
                        this.ride = data.data;
                        if (this.ride.meter) {
                            this.edit_ride.meter_price = this.ride.meter.meter_price;
                        }
                    })
                    .catch(() =>
                        this.$router.push({
                            name: "NotFound"
                        }))
                    .finally(() => this.loading = false);
            },
            selectBooking(item) {
                this.selected_booking = item;
                this.edit_booking.paid = item.paid;
                this.dialog2 = true;
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>

</style>
